import paths from "../paths";

let envBulletinUrl = process.env.REACT_APP_BULLETIN_URL || "https://bulletin.4nala.com";
let envWsUrl = process.env.REACT_APP_WS_URL || "wss://ws.4nala.com/stream";
let envApiUrl = process.env.REACT_APP_API_URL || "https://api.4nala.com";
let webURL = process.env.REACT_APP_WEB_URL || "https://4nala.com";
let isTest = false;

if (
    window.location.host.includes("test") ||
    window.location.host.includes("localhost") ||
    window.location.host.includes("0.0.0.0")
) {
    envBulletinUrl =  "https://test-bulletin.4nala.com";
    envWsUrl = "wss://test-ws.4nala.com/stream";
    envApiUrl = "https://test-api.4nala.com";
    webURL = "https://test.4nala.com";
    isTest = true;
}

// envBulletinUrl =  "http://bulletin.localbulletin.com:9020";
// envWsUrl = "wss://test-ws.4nala.com/stream";
// envApiUrl = "http://10.8.0.5:8080";
// webURL = "https://test.4nala.com";
// isTest = true;

export const bulletinUrlPrefix = `${envBulletinUrl}/api/bulletin`;
export const resultsUrlPrefix = `${envBulletinUrl}/api/results`;
export const possiblesUrlPrefix = `${envBulletinUrl}/api/possibles`;
export const agfUrlPrefix = `${envBulletinUrl}/api/agf/`;
export const agfHistoryUrlPrefix = `https://bulletin.4nala.com/api/agf-history/`;
export const programUrlPrefix = `${envBulletinUrl}/api/races`;
export const jockeyStatusUrlPrefix = `${envBulletinUrl}/api/unavailable_jockeys`;
export const changedJokeyUrlPrefix = `${envBulletinUrl}/api/jockey_changes/`;
export const racecourseUrlPrefix = `${envBulletinUrl}/api/racecourse/`;

export const env: any = {
    accounting_api: `${envApiUrl}`,
    tipsters_api: `${envApiUrl}`,
    betting_api: `${envApiUrl}`,
    cdn_host: `${envApiUrl}`,
    accounting_wss: `${envWsUrl}`,
    web_url:`${webURL}`,
    isTest: isTest,
};

export {
    predefinedConstants,
    wsFunctionTypes,
    longDays,
    shortDays,
    months,
    supportTicketStatus,
    regions,
    passwordModalStyles,
    transTypes,
    professions,
    foreignerTCs,
    nationalities,
} from "./reference.data";

export const redirectionErrorCodes = ["tc_id_exists", "email_exists", "mobile_exists"];

export let warningLogStyle = "color: black; background: yellow; font-size: 12px; font-weight:bold";
export let successLogStyle = "color: white; background: green; font-size: 12px; font-weight:bold";
export let errorLogStyle = "color: white; background: red; font-size: 12px; font-weight:bold";

export const agreements: any = {};
export const flatPages: any = {};
export const news: any = [];

export const listGamePages = [
    paths.scratch.url,
    paths.scratchMyCards.url,
    paths.scartchRules.url,
    paths.superBingo.url,
    paths.zeplin.url,
    paths.fireballs.url,
    paths.fruitTowers.url,
    paths.superWheel.url,
    paths.rockPaperScissors.url,
    paths.turboMines.url,
    paths.crashX.url,
    paths.turboPlinko.url,
    paths.hamsta.url,
];

